import { Box, Divider, ListItem, Typography } from '@mui/material';
import React from 'react';
import { HubCircularImage } from '../HubCircularImage/HubCircularImage';

interface FighterToWatchItemProps {
  name: string;
  image: string;
  opponent: string;
  event: string;
  description: string;
  onClick: () => void;
  isTitleFight: boolean;
  isLoading?: boolean;
}

const FighterToWatchItem: React.FC<FighterToWatchItemProps> = ({
  name,
  image,
  opponent,
  event,
  description,
  onClick,
  isTitleFight,
  isLoading = false,
}) => {
  return (
    <ListItem
      sx={{
        display: 'flex',
        alignItems: 'center',
        mb: 2,
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        border: '1px solid grey',
        borderRadius: '8px',
        '&:hover': {
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          transform: 'translateX(5px)',
          borderColor: 'white',
        },
      }}
      onClick={onClick}
    >
      <Box sx={{ mr: 2 }}>
        <HubCircularImage isLoading={isLoading} imageSrc={image} size={40} />
      </Box>
      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: { xs: 'column', sm: 'row' },
          }}
        >
          <Typography
            variant="body1"
            sx={{
              fontWeight: 'bold',
              flex: { xs: 'none', sm: 1 },
              width: { xs: '100%', sm: 'auto' },
              textAlign: { xs: 'center', sm: 'left' },
              fontSize: { xs: '0.9rem', sm: 'clamp(0.6rem, 2.2vw, 1.0rem)' },
              mb: { xs: 1, sm: 0 },
            }}
          >
            {name} {isTitleFight && '👑'}
          </Typography>
          <Divider
            orientation="vertical"
            flexItem
            sx={{ mx: 2, display: { xs: 'none', sm: 'block' } }}
          />
          <Typography
            variant="body2"
            color="textSecondary"
            sx={{
              flex: { xs: 'none', sm: 2 },
              width: { xs: '100%', sm: 'auto' },
              textAlign: { xs: 'center', sm: 'left' },
              fontSize: { xs: '0.8rem', sm: 'clamp(0.5rem, 2.0vw, 0.8rem)' },
            }}
          >
            vs. {opponent} - {event}
          </Typography>
        </Box>
        <Divider sx={{ my: 1 }} />
        <Typography
          variant="body2"
          color="textSecondary"
          sx={{
            mt: 1,
            fontSize: { xs: '0.8rem', sm: 'clamp(0.6rem, 2.0vw, 0.8rem)' },
            textAlign: { xs: 'center', sm: 'left' },
          }}
        >
          {description}
        </Typography>
      </Box>
    </ListItem>
  );
};

export default FighterToWatchItem;
